import { Component, OnInit, Input, SimpleChanges, ViewChild, forwardRef } from '@angular/core';
import { 
    IonGrid, IonRow, IonCol, IonLabel, IonSpinner, InfiniteScrollCustomEvent, IonInfiniteScroll,  IonInfiniteScrollContent 
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { MarvCircleComponent, MarvProgressBarComponent, MarvMessageComponent, MarvDrawerComponent } from '@marv/components';
import { MarvDateService } from '@marv/services';
import { MissionItem, MissionItemComponent, MissionDetailsComponent } from '@app/components';
import { OrderService, OperationService } from '@app/services';
import { MissionPlanningFilters } from '@app/models';

@Component({
    selector: 'app-mission-today',
    templateUrl: './today.component.html',
    styleUrls: ['./today.component.scss'],
    imports: [
        IonGrid, IonRow, IonCol, IonLabel, IonInfiniteScroll, IonInfiniteScrollContent, IonSpinner, TranslatePipe, 
        forwardRef(() => MarvCircleComponent), forwardRef(() => MarvProgressBarComponent), forwardRef(() => MarvMessageComponent), forwardRef(() => MarvDrawerComponent), 
        forwardRef(() => MissionItemComponent), forwardRef(() => MissionDetailsComponent)
    ]
})
export class MissionTodayComponent  implements OnInit {

    @Input({alias : 'typesMissions', required : false}) typesMissions: Array<string> = [];

    @ViewChild('drawerMissionDetails') drawerMissionDetails: MarvDrawerComponent;

    isFetching: boolean = false;
    missionsItems: Array<MissionItem> = [];
    missionsItemsToDisplay: Array<MissionItem> = [];
    missionsItemsDisplayed: Array<MissionItem> = [];    
    nbPresencesConfirmed: number = 0;
    nbMissionsFinished: number = 0;
    maxMissionsDisplayed: number = 50;
    indexMissionDisplayed: number = 0;
    disabledInfiniteScroll: boolean = false;
    
    missionItemSelected: MissionItem|null = null; 
    
    constructor(
        private orderService: OrderService
    ) { }

    async ngOnInit() {
        await this.loadsMissions();
    }
    
    ngOnChanges(changes: SimpleChanges) {
        if(changes['typesMissions']){
            this.setMissionsToDisplay();
        }
    }
    
    async loadsMissions(){
        this.isFetching = true;
        let today = MarvDateService.FromDate(new Date());
        if(today){
            let filters: MissionPlanningFilters = {
                from: today,
                to: today
            };
            let report = await this.orderService.loadPlanning(filters);
            if(report){   
                this.missionsItems = report.getMissionsItems(OperationService.OperationsSettings);        
                this.setMissionsToDisplay();            
            }
            this.isFetching = false;
        }
    }
    
    setMissionsToDisplay(){
        if(this.typesMissions.length > 0){
            this.missionsItemsToDisplay = this.missionsItems.filter(m => 
                (m.operation && this.typesMissions.indexOf(m.operation?.typeOfMission) !== -1) 
            );
        }
        else{
            this.missionsItemsToDisplay = this.missionsItems;
        }
        this.nbPresencesConfirmed = this.missionsItemsToDisplay.filter(m => m.presenceConfirmed).length;
        this.nbMissionsFinished = this.missionsItemsToDisplay.filter(m => (!m.reportable && m.presenceConfirmed) || m.reportingCompleted).length;
        this.missionsItemsDisplayed = [];
        this.indexMissionDisplayed = 0;
        this.disabledInfiniteScroll = false;
        this.getMissionsDisplayed();
    }
    
    getMissionsDisplayed() {
        let subArray = this.missionsItemsToDisplay.slice(this.indexMissionDisplayed, this.indexMissionDisplayed+this.maxMissionsDisplayed);
        if(subArray.length > 0){
            this.missionsItemsDisplayed = this.missionsItemsDisplayed.concat(subArray);
            this.indexMissionDisplayed += subArray.length;
        }
        else{
            this.disabledInfiniteScroll = true;
        }
    }
    
    onIonInfinite(event: InfiniteScrollCustomEvent) {        
        this.getMissionsDisplayed();
        event.target.complete();
    }
    
    onSelectMission(missionItem: MissionItem){
        this.missionItemSelected = missionItem;
        this.drawerMissionDetails.open();
    }

    onDidDismissDrawerMission($event: any){
        this.missionItemSelected = null;
    }
     
    async onUpdateMission(status: boolean){   
        if(status){ 
            await this.loadsMissions(); 
        }       
    }
    
    async onDeleteMission(status: boolean){
        if(status){
            this.drawerMissionDetails.close();
            await this.loadsMissions();
        }
    }
}
